import {createContext} from 'react';

import {LICENSE_PROVIDER_DEFAULT_VALUE} from './license-provider-helper';
import {LicenseProviderType} from './license-provider-type';

export const LicenseContext = createContext<LicenseProviderType>(LICENSE_PROVIDER_DEFAULT_VALUE);
